// Descarga de la grabación de una llamada como archivo. Portado del CRM
// (apps/web/src/shared/lib/downloadRecording.ts). Pide la URL firmada on-demand
// (igual que el player), trae los bytes y dispara la descarga con un nombre
// estable. Si el fetch directo a GCS falla (p.ej. CORS), degrada a abrir la URL
// firmada en una pestaña nueva.
//
// Nota: la URL firmada apunta a GCS, no al BFF del CRM, así que este fetch NO
// lleva credentials (la firma es la autenticación); por eso no reutiliza
// crmDownload de crm.ts (que va con cookie contra el propio CRM).

import { getRecordingUrl } from "../../api/crmTimeline";

const EXT_BY_MIME: Record<string, string> = {
  "audio/mpeg": "mp3",
  "audio/mp3": "mp3",
  "audio/wav": "wav",
  "audio/x-wav": "wav",
  "audio/ogg": "ogg",
  "audio/mp4": "m4a",
  "audio/aac": "aac",
  "audio/webm": "webm",
};

function extFromUrl(url: string): string | null {
  try {
    const path = new URL(url).pathname;
    const m = /\.([a-z0-9]{2,4})$/i.exec(path);
    return m ? m[1].toLowerCase() : null;
  } catch {
    return null;
  }
}

export async function downloadRecording(callId: string): Promise<void> {
  const { url } = await getRecordingUrl(callId);
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`recording fetch ${res.status}`);
    const blob = await res.blob();
    const ext = EXT_BY_MIME[blob.type.split(";")[0]] ?? extFromUrl(url) ?? "mp3";
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = `llamada-${callId}.${ext}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objectUrl);
  } catch {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}
